// import router from 'vue-router'
const actions = {
};

export default actions

